import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Agreements.css";
import { logHistory } from "../../utils/historyLogger";

function Agreements() {
  const [agreements, setAgreements] = useState([]);
  const role = localStorage.getItem("role");
  const canEdit = role === "admin" || role === "superadmin";
  const canDelete = role === "superadmin";
  // Any logged-in role (user, admin, superadmin) can add data now.
  const canAdd = role === "user" || role === "admin" || role === "superadmin";
  const [search, setSearch] = useState("");
  const [editId, setEditId] = useState(null);

  const [formData, setFormData] = useState({
    agreementType: "",
    supplierName: "",
    startDate: "",
    endDate: "",
    cost: "",
    remark: "",
    status: "Pending",
  });

  useEffect(() => {
    fetchAgreements();
  }, []);

  const fetchAgreements = async () => {
    try {
      const res = await axios.get("https://hrpsc.swisstekaluminium.com/api/agreements");
      setAgreements(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
    const handleSubmit = async () => {
    if (!formData.agreementType) {
      alert("Agreement Type is required");
      return;
    }

    try {
      const payload = {
        agreementType: formData.agreementType || "",
        supplierName: formData.supplierName || "",
        startDate: formData.startDate || "",
        endDate: formData.endDate || "",
        cost: formData.cost || "",
        remark: formData.remark || "",
        status: formData.status || "Pending",
      };

      if (editId) {
        await axios.put(
          `https://hrpsc.swisstekaluminium.com/api/agreements/${editId}`,
          payload
        );

        await logHistory(
          "Agreements",
          "Updated Agreement",
          `Agreement ${formData.agreementType} updated`
        );

        alert("Updated Successfully");
      } else {
        await axios.post("https://hrpsc.swisstekaluminium.com/api/agreements", payload);

        await logHistory(
          "Agreements",
          "Added Agreement",
          `Agreement ${formData.agreementType} added`
        );

        alert("Agreement Added");
      }

      fetchAgreements();
      clearForm();
    } catch (err) {
      console.log(err);
      alert(err.response?.data?.message || "Error Saving Agreement");
    }
  };

  const handleEdit = (item) => {
    setEditId(item.id);

    setFormData({
      agreementType: item.agreementType || "",
      supplierName: item.supplierName || "",
      startDate: item.startDate?.split("T")[0] || "",
      endDate: item.endDate?.split("T")[0] || "",
      cost: item.cost || "",
      remark: item.remark || "",
      status: item.status || "Pending",
    });

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this agreement?")) return;

    try {
      await axios.delete(`https://hrpsc.swisstekaluminium.com/api/agreements/${id}`);

      await logHistory(
        "Agreements",
        "Deleted Agreement",
        "Agreement record deleted"
      );

      fetchAgreements();
    } catch (err) {
      console.log(err);
      alert("Delete Failed");
    }
  };

  const toggleStatus = async (item) => {
    try {
      const updatedStatus = item.status === "Renewed" ? "Pending" : "Renewed";

      await axios.put(`https://hrpsc.swisstekaluminium.com/api/agreements/${item.id}`, {
        ...item,
        status: updatedStatus,
      });

      await logHistory(
        "Agreements",
        "Updated Agreement Status",
        `Agreement ${item.agreementType} status changed to ${updatedStatus}`
      );

      fetchAgreements();
    } catch (err) {
      console.log(err);
      alert("Status Update Failed");
    }
  };

  const clearForm = () => {
    setEditId(null);

    setFormData({
      agreementType: "",
      supplierName: "",
      startDate: "",
      endDate: "",
      cost: "",
      remark: "",
      status: "Pending",
    });
  };

  const downloadCSVReport = () => {
    if (agreements.length === 0) {
      alert("No agreement data to download");
      return;
    }

    const headers = Object.keys(agreements[0]);

    const rows = agreements.map((item) =>
      headers
        .map((field) => `"${String(item[field] ?? "").replace(/"/g, '""')}"`)
        .join(",")
    );

    const csvContent = [headers.join(","), ...rows].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "agreements_report.csv";
    link.click();

    URL.revokeObjectURL(url);
  };

  const filteredData = agreements.filter(
    (item) =>
      item.agreementType?.toLowerCase().includes(search.toLowerCase()) ||
      item.supplierName?.toLowerCase().includes(search.toLowerCase())
  );
    return (
    <div className="agreement-page">
      <h1 className="page-title">Agreements / License Insurance</h1>

      <div className="dashboard-cards">
        <div className="dashboard-card">
          <h3>Total Agreements</h3>
          <h1>{agreements.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Renewed</h3>
          <h1>{agreements.filter((item) => item.status === "Renewed").length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Pending</h3>
          <h1>{agreements.filter((item) => item.status === "Pending").length}</h1>
        </div>
      </div>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search Agreement"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <button className="clear-btn" onClick={() => setSearch("")}>
          Clear
        </button>

        {/* Download available to every role - user downloads their own
            assigned-interface data, admin/superadmin download any interface */}
        <button className="add-btn" onClick={downloadCSVReport}>
          Download Report
        </button>
      </div>

      {/* Add form: user, admin, and superadmin can all add data now.
          The same form is reused for editing an existing record
          (editId gets set by handleEdit). */}
      {(canAdd || editId) && (
        <div className="form-container">
          <input
            type="text"
            name="agreementType"
            placeholder="Agreement Type"
            value={formData.agreementType}
            onChange={handleChange}
          />

          <input
            type="text"
            name="supplierName"
            placeholder="Supplier Name"
            value={formData.supplierName}
            onChange={handleChange}
          />

          <input
            type="date"
            name="startDate"
            value={formData.startDate}
            onChange={handleChange}
          />

          <input
            type="date"
            name="endDate"
            value={formData.endDate}
            onChange={handleChange}
          />

          <input
            type="number"
            name="cost"
            placeholder="Cost"
            value={formData.cost}
            onChange={handleChange}
          />

          <input
            type="text"
            name="remark"
            placeholder="Remark"
            value={formData.remark}
            onChange={handleChange}
          />

          <button className="add-btn" onClick={handleSubmit}>
            {editId ? "Update Agreement" : "Add Agreement"}
          </button>

          <button className="clear-btn" onClick={clearForm}>
            Clear Form
          </button>
        </div>
      )}

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Agreement Type</th>
              <th>Supplier Name</th>
              <th>Starting Date</th>
              <th>Ending Date</th>
              <th>Cost</th>
              <th>Remark</th>
              <th>Renew Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredData.map((item) => (
              <tr key={item.id}>
                <td>{item.agreementType}</td>
                <td>{item.supplierName}</td>
                <td>{item.startDate?.split("T")[0]}</td>
                <td>{item.endDate?.split("T")[0]}</td>
                <td>Rs. {item.cost}</td>
                <td>{item.remark}</td>

                <td>
                  {/* Approving / changing status is an admin & super
                      admin action - a "user" just sees the current status */}
                  {canEdit ? (
                    <button
                      className={
                        item.status === "Renewed"
                          ? "status-renewed"
                          : "status-pending"
                      }
                      onClick={() => toggleStatus(item)}
                    >
                      {item.status}
                    </button>
                  ) : (
                    <span
                      className={
                        item.status === "Renewed"
                          ? "status-renewed"
                          : "status-pending"
                      }
                    >
                      {item.status}
                    </span>
                  )}
                </td>

                <td>
                  {canEdit && (
                    <button
                      className="edit-btn"
                      onClick={() => handleEdit(item)}
                    >
                      Edit
                    </button>
                  )}

                  {canDelete && (
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(item.id)}
                    >
                      Delete
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Agreements;